export default "__VITE_ASSET__GUy94G13__"